<template>
  <v-row class="ma-0">
    <v-col cols="12">
      <v-card class="elevation-0 pa-4">
        <v-row class="ma-0">
          <v-col cols="6">
            <v-row class="ma-0 justify-center" style="border:1px solid #4a4a4a;">
              <v-col cols="4" class="px-0">
                <div class="tabla header-empty"></div>
                <div class="tabla cell-label"><span>{{ price1Label }}</span></div>
                <div class="tabla cell-label"><span>PRECIO 2</span></div>
                <div class="tabla cell-label"><span>PRECIO 3</span></div>
                <div class="tabla cell-label"><span>{{ price4Label }}</span></div>
              </v-col>
              <v-col cols="4" class="px-0">
                <div class="tabla header-mode">
                  <v-checkbox style="margin:auto;font-weight:500;" :hide-details="true" :input-value="editMode === 'sin_iva'" label="SIN IVA" @change="setEditMode('sin_iva')" />
                </div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="sin_iva" :value="localDraft.price" @input="onEditPriceNoIva('1', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="sin_iva" :value="localDraft.price_two" @input="onEditPriceNoIva('2', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="sin_iva" :value="localDraft.price_three" @input="onEditPriceNoIva('3', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="sin_iva" :value="localDraft.price_four" @input="onEditPriceNoIva('4', $event)" /></div>
              </v-col>
              <v-col cols="4" class="px-0">
                <div class="tabla header-mode">
                  <v-checkbox style="margin:auto;font-weight:500;" :hide-details="true" :input-value="editMode === 'con_iva'" label="CON IVA" @change="setEditMode('con_iva')" />
                </div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="con_iva" :value="localDraft.price_iva" @input="onEditPriceIva('1', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="con_iva" :value="localDraft.price_two_iva" @input="onEditPriceIva('2', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="con_iva" :value="localDraft.price_three_iva" @input="onEditPriceIva('3', $event)" /></div>
                <div class="tabla cell-value"><PriceCell :editMode="editMode" columnMode="con_iva" :value="localDraft.price_four_iva" @input="onEditPriceIva('4', $event)" /></div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="ma-0" style="border:1px solid #4a4a4a;">
              <v-col cols="5" class="pa-0">
                <div class="tabla header-mode"><div style="margin:auto;"><span style="font-weight:500;">COSTO (sin IVA)</span></div></div>
                <div class="tabla" style="height:360px!important;background:#fff;">
                  <v-text-field outlined hide-details rounded style="margin:auto;" prefix="$" class="mx-6" v-model="localDraft.current_cost_input" @blur="onEditCost" />
                </div>
              </v-col>
              <v-col cols="7" class="pa-0">
                <div class="tabla header-mode">
                  <div style="margin:auto;display:flex;align-items:center;gap:8px;">
                    <span style="font-weight:500;">UTILIDAD</span>
                    <v-icon small @click="setEditMode('utilidad')" style="cursor:pointer;">mdi-pencil</v-icon>
                  </div>
                </div>
                <div class="tabla cell-value"><UtilityCell tier="1" :editMode="editMode" :price="localDraft.price" :priceIva="localDraft.price_iva" :currentCost="localDraft.current_cost" :profitMargin="localDraft.profit_margin_1" @update:profit-margin="val => onEditProfit('1', val)" /></div>
                <div class="tabla cell-value"><UtilityCell tier="2" :editMode="editMode" :price="localDraft.price_two" :priceIva="localDraft.price_two_iva" :currentCost="localDraft.current_cost" :profitMargin="localDraft.profit_margin_2" @update:profit-margin="val => onEditProfit('2', val)" /></div>
                <div class="tabla cell-value"><UtilityCell tier="3" :editMode="editMode" :price="localDraft.price_three" :priceIva="localDraft.price_three_iva" :currentCost="localDraft.current_cost" :profitMargin="localDraft.profit_margin_3" @update:profit-margin="val => onEditProfit('3', val)" /></div>
                <div class="tabla cell-value"><UtilityCell tier="4" :editMode="editMode" :price="localDraft.price_four" :priceIva="localDraft.price_four_iva" :currentCost="localDraft.current_cost" :profitMargin="localDraft.profit_margin_4" @update:profit-margin="val => onEditProfit('4', val)" /></div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import PriceCell from '@/components/products/calculadora/PriceCell.vue'
import UtilityCell from '@/components/products/calculadora/UtilityCell.vue'
import { priceWithIva, priceWithoutIva } from './pricing'
export default {
  name: 'ProductPricingStep',
  components: { PriceCell, UtilityCell },
  props: { value: { type: Object, required: true } },
  data() {
    return { editMode: 'sin_iva', localDraft: this.buildDraft(this.value || {}) }
  },
  computed: {
    backendBase() { return process.env.VUE_APP_BACKEND_ROUTE },
    price1Label() { return this.backendBase == 'https://backend.ferreteriaenlinea.com/' ? 'Precio Mayoreo' : 'PRECIO 1' },
    price4Label() { return this.backendBase == 'https://backend.ferreteriaenlinea.com/' ? 'Precio Mostrador' : 'PRECIO 4' }
  },
  watch: {
    value: {
      deep: true,
      handler(val) { this.localDraft = this.buildDraft(val || {}) }
    }
  },
  methods: {
    normalizeNumber(v) { const n = parseFloat(v); return isNaN(n) ? 0 : n },
    buildDraft(item) {
      const current_cost = this.normalizeNumber(item.current_cost || item.cost)
      const price = this.normalizeNumber(item.price)
      const price_two = this.normalizeNumber(item.price_two)
      const price_three = this.normalizeNumber(item.price_three)
      const price_four = this.normalizeNumber(item.price_four)
      return {
        current_cost,
        current_cost_input: current_cost ? String(current_cost.toFixed(2)) : '',
        price,
        price_two,
        price_three,
        price_four,
        price_iva: this.normalizeNumber(priceWithIva(price)),
        price_two_iva: this.normalizeNumber(priceWithIva(price_two)),
        price_three_iva: this.normalizeNumber(priceWithIva(price_three)),
        price_four_iva: this.normalizeNumber(priceWithIva(price_four)),
        profit_margin_1: this.normalizeNumber(item.profit_margin_1),
        profit_margin_2: this.normalizeNumber(item.profit_margin_2),
        profit_margin_3: this.normalizeNumber(item.profit_margin_3),
        profit_margin_4: this.normalizeNumber(item.profit_margin_4)
      }
    },
    emitChange() {
      this.$emit('input', {
        ...this.value,
        cost: this.localDraft.current_cost,
        current_cost: this.localDraft.current_cost,
        price: this.localDraft.price,
        price_two: this.localDraft.price_two,
        price_three: this.localDraft.price_three,
        price_four: this.localDraft.price_four,
        profit_margin_1: this.localDraft.profit_margin_1,
        profit_margin_2: this.localDraft.profit_margin_2,
        profit_margin_3: this.localDraft.profit_margin_3,
        profit_margin_4: this.localDraft.profit_margin_4
      })
    },
    setEditMode(mode) { this.editMode = mode },
    calcMarginPct(priceNoIva) {
      const p = this.normalizeNumber(priceNoIva)
      const c = this.normalizeNumber(this.localDraft.current_cost)
      if (!c || c <= 0) return 0
      return (((p - c) / c) * 100).toFixed(2)
    },
    onEditPriceNoIva(tier, val) {
      const clean = this.normalizeNumber(val)
      if (tier === '1') { this.localDraft.price = clean; this.localDraft.price_iva = priceWithIva(clean); this.localDraft.profit_margin_1 = this.calcMarginPct(clean) }
      if (tier === '2') { this.localDraft.price_two = clean; this.localDraft.price_two_iva = priceWithIva(clean); this.localDraft.profit_margin_2 = this.calcMarginPct(clean) }
      if (tier === '3') { this.localDraft.price_three = clean; this.localDraft.price_three_iva = priceWithIva(clean); this.localDraft.profit_margin_3 = this.calcMarginPct(clean) }
      if (tier === '4') { this.localDraft.price_four = clean; this.localDraft.price_four_iva = priceWithIva(clean); this.localDraft.profit_margin_4 = this.calcMarginPct(clean) }
      this.emitChange()
    },
    onEditPriceIva(tier, val) {
      const clean = this.normalizeNumber(val)
      if (tier === '1') { this.localDraft.price_iva = clean; this.localDraft.price = priceWithoutIva(clean); this.localDraft.profit_margin_1 = this.calcMarginPct(this.localDraft.price) }
      if (tier === '2') { this.localDraft.price_two_iva = clean; this.localDraft.price_two = priceWithoutIva(clean); this.localDraft.profit_margin_2 = this.calcMarginPct(this.localDraft.price_two) }
      if (tier === '3') { this.localDraft.price_three_iva = clean; this.localDraft.price_three = priceWithoutIva(clean); this.localDraft.profit_margin_3 = this.calcMarginPct(this.localDraft.price_three) }
      if (tier === '4') { this.localDraft.price_four_iva = clean; this.localDraft.price_four = priceWithoutIva(clean); this.localDraft.profit_margin_4 = this.calcMarginPct(this.localDraft.price_four) }
      this.emitChange()
    },
    priceFromMargin(marginPct) {
      const pct = this.normalizeNumber(marginPct)
      const c = this.normalizeNumber(this.localDraft.current_cost)
      if (!c) return 0
      return (pct / 100) * c + c
    },
    applyMarginToTier(tier, pct) {
      const baseNum = this.priceFromMargin(pct)
      const withIva = priceWithIva(baseNum)
      if (tier === '1') { this.localDraft.price = baseNum; this.localDraft.price_iva = withIva }
      if (tier === '2') { this.localDraft.price_two = baseNum; this.localDraft.price_two_iva = withIva }
      if (tier === '3') { this.localDraft.price_three = baseNum; this.localDraft.price_three_iva = withIva }
      if (tier === '4') { this.localDraft.price_four = baseNum; this.localDraft.price_four_iva = withIva }
    },
    onEditProfit(tier, val) {
      const pct = this.normalizeNumber(val)
      if (tier === '1') { this.localDraft.profit_margin_1 = pct; this.applyMarginToTier('1', pct) }
      if (tier === '2') { this.localDraft.profit_margin_2 = pct; this.applyMarginToTier('2', pct) }
      if (tier === '3') { this.localDraft.profit_margin_3 = pct; this.applyMarginToTier('3', pct) }
      if (tier === '4') { this.localDraft.profit_margin_4 = pct; this.applyMarginToTier('4', pct) }
      this.emitChange()
    },
    onEditCost() {
      const clean = this.normalizeNumber(this.localDraft.current_cost_input)
      this.localDraft.current_cost = clean
      this.localDraft.current_cost_input = clean ? clean.toFixed(2) : ''
      this.localDraft.profit_margin_1 = this.calcMarginPct(this.localDraft.price)
      this.localDraft.profit_margin_2 = this.calcMarginPct(this.localDraft.price_two)
      this.localDraft.profit_margin_3 = this.calcMarginPct(this.localDraft.price_three)
      this.localDraft.profit_margin_4 = this.calcMarginPct(this.localDraft.price_four)
      this.emitChange()
    }
  }
}
</script>
<style scoped>
.tabla { border: 1px solid #4a4a4a !important; border-radius: 0 !important; min-height: 90px; display: flex !important; align-items: center; justify-content: center; text-align: center; background:#fff; }
.header-mode { background:#d9e4ff; font-weight:500; }
.header-empty { background:#fff; }
.cell-label { background:#fff; font-weight:500; }
.cell-value { background:#fff; }
</style>
